/* @flow */

import React from 'react';
import { Segment, Menu, Form, Grid } from 'semantic-ui-react';
import OctoResourceCard from 'shared/components/OctoResourceCard';
import HeaderPageSelector from './HeaderPageSelector';
import type { HomeContentHeader } from '../index';

type Props = {
  header: HomeContentHeader,
  onHeaderUpdated: (header: HomeContentHeader) => void,
};

const HomeHeader = ({ header, onHeaderUpdated }: Props) => {
  const onTitleChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onHeaderUpdated({
        ...header,
        title: event.target.value,
      });
    }
  };

  const onPageSelected = page =>
    onHeaderUpdated({
      ...header,
      pageId: page.id,
      page,
    });

  const onPageDeleted = () =>
    onHeaderUpdated({
      ...header,
      pageId: undefined,
      page: undefined,
    });

  const resourceUpdated = (resource: CatalogResource) =>
    onHeaderUpdated({
      ...header,
      image: resource,
    });

  const resourceDeleted = () =>
    onHeaderUpdated({
      ...header,
      image: undefined,
    });

  return (
    <div>
      <Menu attached="top" borderless>
        <Menu.Item header>Catalogue</Menu.Item>
      </Menu>
      <Segment attached="bottom">
        <Grid verticalAlign="middle">
          <Grid.Column width={6}>
            <Form>
              <Form.Input
                label="Titre"
                value={header.title}
                onChange={onTitleChange}
              />
              <HeaderPageSelector
                header={header}
                onPageSelected={onPageSelected}
                onPageDeleted={onPageDeleted}
              />
            </Form>
          </Grid.Column>
          <Grid.Column width={2} />
          <Grid.Column width={8}>
            <OctoResourceCard
              strategy={header.resourceStrategy}
              resource={header.image}
              onUpdated={resourceUpdated}
              onDeleted={resourceDeleted}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    </div>
  );
};

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/home/components/HomeHeader.js